import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a10350d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "animate"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mis Preguntas", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "search-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "modern-table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ForumService from '@/services/ForumService';
import { onMounted, ref, Ref } from 'vue';
import { useAuth } from '@/store/useAuth';
import useWindowWidth from '@/composables/useWindowWidth';
import main from '@/data/main.js';
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyQuestionsView',
  setup(__props) {

const forumService = new ForumService()
const items:Ref<any> = ref([])
const filtered:Ref<any> = ref([])
const loading = ref(true)
const search = ref('')
const store = useAuth()
const {windowWidth} = useWindowWidth()
const tableSmall= ref(600);

onMounted(async () => {
    if(!store.token) { return }
    loading.value = true
    items.value = await forumService.GetUserQuestions(store.token);
    filtered.value = items.value;
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filtered.value = items.value.filter((item:any) => item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar.",
                onKeyup: handleSearch,
                class: "input-job"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_1_QUESTION_VIEW), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_2_QUESTION_VIEW), 1),
                    (_unref(windowWidth)>tableSmall.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_unref(main).TH_3_QUESTION_VIEW), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_4_QUESTION_VIEW), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        (item?.is_solved == '0')
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              name: "ri-forbid-fill",
                              fill: "#ccc",
                              scale: "2"
                            }))
                          : _createCommentVNode("", true),
                        (item.is_solved == '1')
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              name: "bi-check-circle-fill",
                              fill: _unref(main).THIRD_COLOR,
                              scale: "2"
                            }, null, 8, ["fill"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      (_unref(windowWidth)>tableSmall.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(new Date(item.updated_at).getDate()) + "/" + _toDisplayString(new Date(item.updated_at).getMonth()+1) + "/" + _toDisplayString(new Date(item.updated_at).getFullYear()), 1))
                        : _createCommentVNode("", true),
                      (item.course_id)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'detail-question-lessons-course', params: { course_id: item.course_id, lesson_id: item.lesson_id, question_id: item.id } }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-fileopen-round",
                                  class: "ver",
                                  fill: _unref(main).SECONDARY_COLOR,
                                  scale: "2"
                                }, null, 8, ["fill"])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_12, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'detail-question-general', params: { topic_id: item.topic_id, question_id: item.id, topic_name: item.topic.name } }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-fileopen-round",
                                  class: "ver",
                                  fill: _unref(main).SECONDARY_COLOR,
                                  scale: "2"
                                }, null, 8, ["fill"])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})